import React from 'react';
import {
  SingleSelectionConfigurator,
  SurveyFactory,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const RSALLMSuggestionMostWantedSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'RecommendationRSALLMMostWantedSurvey',
    style: {
      root: {
        maxWidth: 500,
      },
    },
    others: {
      shouldHideInputWhenNotSelected: true,
      userActionAnalysisEnabled: true,
      combineTextInputToComment: true,
      isUserInitiatedSurvey: true,
    },
    questions: [
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('We\'ll prioritize the features of recommending assets for responsive search ads. Please tell us about the features you\'d like us to include.')),
        isVisible: true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('I want to customize headlines or descriptions recommendations.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('I want to create responsive search ads in bulk.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('I want to customize the recommended asset language.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('Other (please elaborate below)')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 2000,
          },
        ],
        data: {
        },
      },
    ],
  };
};

export const FactorySurveyView = props => (
  <SurveyFactory
    getSurveyConfiguration={RSALLMSuggestionMostWantedSurveyConfig}
    {...props}
  />);
